"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigDecimal_1 = require("./BigDecimal");

var BigDecimalPInf =
/*#__PURE__*/
function (_BigDecimal_1$BigDeci) {
  _inherits(BigDecimalPInf, _BigDecimal_1$BigDeci);

  function BigDecimalPInf() {
    _classCallCheck(this, BigDecimalPInf);

    return _possibleConstructorReturn(this, _getPrototypeOf(BigDecimalPInf).call(this));
  }

  _createClass(BigDecimalPInf, [{
    key: "add",
    value: function add(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (other.isNaN()) {
        return BigDecimal_1.BigDecimal.NaN;
      }

      if (other.isInfinity()) {
        return other.sign() > 0 ? this : BigDecimal_1.BigDecimal.NaN;
      }

      return this;
    }
  }, {
    key: "sub",
    value: function sub(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      return this.add(other.negate());
    }
  }, {
    key: "mul",
    value: function mul(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (other.isNaN() || other.isZero()) {
        return BigDecimal_1.BigDecimal.NaN;
      }

      return other.sign() > 0 ? BigDecimal_1.BigDecimal.PInf : BigDecimal_1.BigDecimal.NInf;
    }
  }, {
    key: "div",
    value: function div(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (other.isNaN() || other.isInfinity()) {
        return BigDecimal_1.BigDecimal.NaN;
      }

      if (other.isZero()) {
        return this;
      }

      return other.sign() > 0 ? BigDecimal_1.BigDecimal.PInf : BigDecimal_1.BigDecimal.NInf;
    }
  }, {
    key: "negate",
    value: function negate() {
      return BigDecimal_1.BigDecimal.NInf;
    }
  }, {
    key: "isInfinity",
    value: function isInfinity() {
      return true;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return false;
    }
  }, {
    key: "sign",
    value: function sign() {
      return 1;
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return false;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (other.isNaN()) {
        return false;
      }

      return other.isInfinity() && other.sign() > 0;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return 2;
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (other.isNaN()) {
        return false;
      }

      return other.isInfinity() ? other.sign() < 0 : true;
    }
  }, {
    key: "abs",
    value: function abs() {
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'Infinity';
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return Infinity;
    }
  }, {
    key: "min",
    value: function min(other) {
      return other;
    }
  }, {
    key: "max",
    value: function max(other) {
      if (other.isNaN()) {
        return other;
      }

      return this;
    }
  }]);

  return BigDecimalPInf;
}(BigDecimal_1.BigDecimal);

exports.BigDecimalPInf = BigDecimalPInf;